import { useMemo, useEffect, useRef } from 'react';

import { useInvisibleRecaptcha } from '@atlassian/google-recaptcha';

import { ANALYTICS_CHANNEL } from '../../analytics/constants';
import { AnalyticsActionSubject } from '../../types';
import { getRecaptchaSiteKey } from '../../utils';
import { useInvitePeopleContext } from '../InvitePeople';
import { recaptchaLoaded } from '../../analytics/ufoExperiences';

const useInvisibleRecaptchaWithUFO = () => {
	const { source } = useInvitePeopleContext();
	const { isRecaptchaLoaded, getRecaptchaToken, recaptchaLoadErrorReason } = useInvisibleRecaptcha({
		siteKey: getRecaptchaSiteKey(),
		displayBadge: false,
		analyticsChannel: ANALYTICS_CHANNEL,
		analyticsSource: `${AnalyticsActionSubject.DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL}_${source}`,
	});

	const isInitialLoad = useRef(true);

	useEffect(() => {
		if (isInitialLoad.current) {
			recaptchaLoaded.start();
			isInitialLoad.current = false;
		}
		if (isRecaptchaLoaded) {
			recaptchaLoaded.success();
		}
		if (recaptchaLoadErrorReason) {
			recaptchaLoaded.failure();
		}
	}, [isRecaptchaLoaded, getRecaptchaToken, recaptchaLoadErrorReason]);

	const isRecaptchaLoading = !isRecaptchaLoaded && !recaptchaLoadErrorReason;

	return useMemo(
		() => ({ getRecaptchaToken, isRecaptchaLoading, recaptchaLoadErrorReason }),
		[getRecaptchaToken, isRecaptchaLoading, recaptchaLoadErrorReason],
	);
};

export default useInvisibleRecaptchaWithUFO;
